import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import styles from './HomePage.module.scss';
import SendMessageIcon from '../../assets/send-fill.svg';
import CloseIcon from '../../assets/closeDesktop.svg';
import { TextareaAutosize } from '@mui/base/TextareaAutosize';
import { useAppDispatch, useAppSelector } from "../../hooks/hook";
import { changeMessage, setEmojiState, setSelectedEmoji } from "../../store/slices/appSlice";
import { messagesAPI } from "../../API/api";
import EmojiIcon from '../../assets/emoji-smile-fill.svg';
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import { insertPipeBetweenLinks } from "../../utils/utils";
import classNames from "classnames";
const EmojiControl = () => {
    const dispatch = useAppDispatch();
    const isOpen = useAppSelector(state => state.app.emojiIsOpen);
    const handleClick = () => dispatch(setEmojiState(!isOpen));
    return (_jsx("div", { className: styles.inputNewMessage__activateEmoji, title: 'emoji', children: _jsx(EmojiIcon, { fontSize: '1.2rem', cursor: 'pointer', onClick: handleClick }) }));
};
const InputNewMessage = ({ chatInfo }) => {
    const dispatch = useAppDispatch();
    const selectedChat = useAppSelector(state => state.app.selectedChat);
    const currentUser = useAppSelector(state => state.app.currentUser);
    const isEditMessage = useAppSelector(state => state.app.changeMessage);
    const selectedEmoji = useAppSelector(state => state.app.selectedEmoji);
    const isCheckBox = useAppSelector(state => state.app.showCheckbox);
    const replyToMessage = useAppSelector(state => state.app.replyToMessage);
    const isFavorites = useAppSelector(state => state.app.isFavorites);
    const { t } = useTypedTranslation();
    const isChannel = chatInfo.channel ? true : false;
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone === true;
    const [newMessage, setNewMessage] = useState('');
    const handleChange = (e) => {
        setNewMessage(e.target.value);
    };
    const refTextarea = useRef(null);
    const [editMessage, setEditMessage] = useState('');
    const handleChangeEditMessage = (e) => {
        setEditMessage(e.target.value);
    };
    const sendMessage = () => {
        if (!newMessage.trim())
            return;
        const checkLink = insertPipeBetweenLinks(newMessage);
        const send = () => messagesAPI.sendMessage(chatInfo, currentUser, checkLink, isFavorites, replyToMessage)
            .then(() => {
            setNewMessage('');
            if (replyToMessage)
                cancelEditing();
        })
            .catch((error) => console.error("Ошибка отправки сообщения:", error));
        if (!isFavorites && !isChannel) {
            Promise.all([
                messagesAPI.addChat(currentUser, selectedChat, chatInfo.chatID),
                messagesAPI.addChat(selectedChat, currentUser, chatInfo.chatID)
            ]).then(send);
        }
        else {
            send();
        }
    };
    const sendEditMessage = () => {
        if (!editMessage.trim())
            return;
        const checkLink = insertPipeBetweenLinks(editMessage);
        messagesAPI.sendEditMessage(chatInfo, Object.assign(Object.assign({}, isEditMessage), { message: checkLink }), isFavorites)
            .then(() => dispatch(changeMessage(null)))
            .catch((error) => console.error("Ошибка отправки сообщения:", error));
    };
    const cancelEditing = () => {
        dispatch(changeMessage(null));
    };
    const onKeyDown = (e) => {
        if (e.key === 'Escape' && (isEditMessage || replyToMessage))
            dispatch(changeMessage(null));
    };
    useEffect(() => {
        window.addEventListener('keydown', onKeyDown);
        return () => {
            //console.log('снимаю слушатель')
            return window.removeEventListener('keydown', onKeyDown);
        };
    }, [newMessage, editMessage, isEditMessage, replyToMessage]);
    useEffect(() => {
        var _a, _b;
        if (isEditMessage) {
            setEditMessage(isEditMessage.message);
            (_a = refTextarea.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        if (replyToMessage) {
            (_b = refTextarea.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }, [isEditMessage, replyToMessage]);
    useEffect(() => {
        dispatch(changeMessage(null));
        return () => setNewMessage('');
    }, [selectedChat]);
    useEffect(() => {
        var _a;
        if (selectedEmoji) {
            !isEditMessage ? setNewMessage(prev => prev + selectedEmoji) : setEditMessage(prev => prev + selectedEmoji);
            (_a = refTextarea.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        dispatch(setSelectedEmoji(''));
    }, [selectedEmoji]);
    if (isCheckBox)
        return null;
    if ((chatInfo === null || chatInfo === void 0 ? void 0 : chatInfo.channel) && (chatInfo === null || chatInfo === void 0 ? void 0 : chatInfo.channel.owner.uid) !== currentUser.uid)
        return null;
    return (_jsxs("div", { className: classNames(styles.inputNewMessage, { [styles.inputNewMessage_pwa]: isStandalone }), children: [_jsxs("div", { className: styles.inputNewMessage__textarea, children: [isEditMessage &&
                        _jsxs("div", { className: styles.textarea__isEdit, children: [_jsx("span", { children: t('editing') }), _jsx(CloseIcon, { onClick: cancelEditing })] }), replyToMessage &&
                        _jsxs("div", { className: styles.textarea__isEdit, children: [_jsx("span", { children: t('answer') }), _jsx(CloseIcon, { onClick: cancelEditing })] }), !isEditMessage ?
                        _jsx(TextareaAutosize, { maxRows: 3, value: newMessage, onChange: handleChange, ref: refTextarea, className: styles.textarea, placeholder: t('message') })
                        :
                            _jsx(TextareaAutosize, { maxRows: 3, value: editMessage, onChange: handleChangeEditMessage, ref: refTextarea }), _jsx(EmojiControl, {})] }), _jsx("div", { className: styles.inputNewMessage__button, title: t('sendMessage'), children: _jsx(SendMessageIcon, { fontSize: '2rem', cursor: 'pointer', onClick: !isEditMessage ? sendMessage : sendEditMessage }) })] }));
};
export default InputNewMessage;
